import _ from 'underscore';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { getEntityFromScope } from '@bingads-webui/edm-campaign';
import { isBillingLinkPermission } from '@bingads-webui/multi-agency-utils';

export const withTopTwoCampaigns = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { permissions, scope = {}, settingsContext } = props;
    const [topTwoCampaigns, setTopTwoCampaigns] = useState();
    useEffect(() => {
      if (!_.get(permissions, 'IsInternalUser') && isBillingLinkPermission(settingsContext)) {
        setTopTwoCampaigns([]);
      } else {
        const { currentAccount } = getEntityFromScope(scope);
        if (_.isFunction(_.get(currentAccount, ['Campaigns', 'get']))) {
          currentAccount.Campaigns
            .get({ top: 2, skip: 0, select: ['Id', 'CampaignType'] })
            .subscribe({
              next: c => setTopTwoCampaigns(c),
              error: setTopTwoCampaigns([]),
            });
        }
      }
    }, [scope, permissions, settingsContext]);

    return (<WrappedComponent {...props} topTwoCampaigns={topTwoCampaigns} />);
  };

  Wrapper.propTypes = {
    scope: PropTypes.shape({}).isRequired,
    permissions: PropTypes.shape({}).isRequired,
    settingsContext: PropTypes.shape({}).isRequired,
  };
  Wrapper.displayName = `withCurrentCampaign(
      ${getDisplayName(WrappedComponent)}
    )`;

  hoistNonReactStatics(Wrapper, WrappedComponent);
  return Wrapper;
};
